/** Anything with a person-shaped name: a `user_account`, a CRM contact, a GraphQL fragment of either. */
type NamedUser = { firstName: string; lastName: string };

/**
 * A user's name for display.
 *
 * Not every account has two names. Alby has one (B-1949), and `${firstName} ${lastName}` leaves a
 * trailing space behind it — which is not cosmetic wherever the result is joined ("Alby , Kate
 * Mazza") or wrapped in markdown emphasis (`**Alby **` is literal asterisks, because CommonMark
 * will not close emphasis after whitespace).
 *
 * Lives here rather than in `@qw/ui` so the API, the agent portal and the inbox can all reach the
 * same one. An absent user renders as the empty string, matching what JSX already did for
 * `{user?.firstName} {user?.lastName}`.
 */
export const userDisplayName = (user?: NamedUser | null): string =>
  user ? `${user.firstName} ${user.lastName}`.trim() : "";

/**
 * The one or two letters an avatar shows. Separate from {@link userDisplayName} because it has to
 * survive a missing surname too: `lastName[0]` on a one-name account renders "Aundefined".
 */
export const userInitials = (user?: NamedUser | null): string =>
  user ? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}` : "";
